import { Grid, Paper } from "@material-ui/core";
import TextInputField from "components/Admin/InputFields/TextInputField";
import {
  BorderLinearProgress,
  FIELDS,
  ProgressBar,
  SubmitButton,
} from "components/Admin/InputFields/utils";
import { setAccessories } from "features/admin/Accessories/accessoriesAdminSlice";
import { setResponse } from "features/admin/adminSlice";
import { setProducts } from "features/admin/Products/productsAdminSlice";
import { Field } from "features/admin/Products/types";
import { useStyles } from "features/admin/styles";
import { checkout } from "features/payment/paymentSlice";
import React, { memo, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { MdSave } from "react-icons/md";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import ProductTabs from "../components/ProductTabs";
import { fetchOrders, setOrderElements } from "../ordersAdminSlice";

const orderFields: Field[] = [
  {
    required: true,
    type: "text",
    title: "Име",
    name: "firstName",
    rules: {
      required: { value: true, message: "Полето е задължително" },
    },
  },

  {
    required: true,
    type: "text",
    title: "Град",
    name: "city",
    rules: {
      required: { value: true, message: "Полето е задължително" },
    },
  },
  {
    required: true,
    type: "text",
    title: "Фамилия",
    name: "lastName",
    rules: {
      required: { value: true, message: "Полето е задължително" },
    },
  },
  {
    required: true,
    type: "text",
    title: "Адрес",
    name: "address",
    rules: {
      required: { value: true, message: "Полето е задължително" },
    },
  },

  {
    required: true,
    type: "text",
    title: "Телефон",
    name: "phone",
    rules: {
      required: { value: true, message: "Полето е задължително" },
    },
  },
  {
    required: true,
    type: "text",
    title: "Пощенски код",
    name: "postCode",
    rules: {
      required: { value: true, message: "Полето е задължително" },
    },
  },
  {
    required: true,
    type: "text",
    title: "Имейл адрес",
    name: "email",
    rules: {
      required: { value: true, message: "Полето е задължително" },
    },
  },

  {
    required: true,
    type: "select",
    title: "Вид плащане",
    name: "paymentType",
    options: ["Банков трансфер", "При доставка"],
  },
  {
    required: false,
    type: "text",
    title: "Име на фирмата",
    name: "companyInvoice",
  },
  {
    required: false,
    type: "text",
    title: "МОЛ",
    name: "molInvoice",
  },
  {
    required: false,
    type: "text",
    title: "ЕИК",
    name: "eikInvoice",
  },
  {
    required: false,
    type: "text",
    title: "ДДС номер",
    name: "ddsInvoice",
  },
  {
    required: false,
    type: "text",
    title: "Адрес на фирмата",
    name: "addressInvoice",
  },
];

interface AddOrderProps {}

const AddOrder: React.FC<AddOrderProps> = ({}) => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const { setValue, handleSubmit, control, errors, getValues } = useForm();
  const inputHasBeenRendered = useRef<boolean>(false);

  const classes = useStyles();
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    if (data.items.length === 0) {
      dispatch(
        setResponse({
          message: "Моля, добавете климатик към поръчката!",
          hasError: false,
        })
      );
      return;
    }

    dispatch(
      checkout(data, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    dispatch(fetchOrders());
    navigate(-1);
  };

  const renderField = (field: Field, idx: number) => {
    const value = getValues(field.name);
    if (value) {
      field.value = value;
    }

    const Field = FIELDS[field.type];

    return (
      <Field
        item={field}
        key={idx}
        control={control}
        reset={false}
        setValue={setValue}
        errors={errors}
        value={value}
      />
    );
  };

  useEffect(() => {
    setValue("items", []);
    return () => {
      dispatch(setOrderElements([]));
      dispatch(setProducts([]));
      dispatch(setAccessories([]));
    };
  }, []);

  return (
    <AddOrderContainer>
      <Paper className={classes.paper}>
        <h1>Добави поръчка</h1>

        <Grid container direction="row" wrap="wrap" align-items="center">
          <AddOrderForm
            onSubmit={handleSubmit(onSubmit)}
            encType="multipart/form-data"
          >
            {orderFields.map((item, idx) => {
              return renderField(item, idx);
            })}
            <HiddenInput>
              <TextInputField
                item={{
                  required: true,
                  type: "text",
                  title: "Добавени климатици",
                  name: "items",
                  rules: {
                    required: { value: true, message: "Полето е задължително" },
                  },
                }}
                control={control}
                reset={false}
                setValue={setValue}
                errors={errors}
              />
            </HiddenInput>
            <ProductTabs getValues={getValues} setValue={setValue} />
            <ProgressBar>
              <BorderLinearProgress variant="determinate" value={progress} />
            </ProgressBar>
            <StyledSubmitButton
              variant="contained"
              color="primary"
              type="submit"
              startIcon={<MdSave size="1.5rem" />}
            >
              Добави поръчка
            </StyledSubmitButton>
          </AddOrderForm>
        </Grid>
      </Paper>
    </AddOrderContainer>
  );
};

const AddOrderContainer = styled.div`
  flex: 1;
`;

export const AddOrderForm = styled.form`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;

  .MuiFormControl-root {
    flex-basis: 45%;
  }
`;

const StyledSubmitButton = styled(SubmitButton)`
  flex-basis: 100%;
`;

export const HiddenInput = styled.div`
  display: none;
`;

export default memo(AddOrder);
